import TrainingGridAccordion from './TrainingGridAccordion';

export default TrainingGridAccordion;
